import FormGroupAPI from './form_group_api';

export const create = (formGroup, constructorArgs = {}) => {
	const apiClass = getAPIClass();

    return new apiClass(Object.assign({
		id: formGroup.id,
		identifier: formGroup.identifier,
		name: formGroup.name,
		expansible: formGroup.expansible
		//fieldGroupingId: formGroup.fieldGroupingId
    }, constructorArgs));
};

const getAPIClass = () => {
    return FormGroupAPI;
};

export default {
    create
};
